var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{staticClass:"flex column page-layout latest-news"},[_c('NewsAll')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }